import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from '../components/Layout';
import Login from '../views/auth/Login';
import Dashboard from '../views/dashboard/Dashboard';
import ConfiguracionNegocio from '../views/modules/ConfiguracionNegocio';
import Clientes from '../views/modules/Clientes';
import Proveedores from '../views/modules/Proveedores';
import Productos from '../views/modules/Productos';
import Compras from '../views/modules/Compras';
import Ventas from '../views/modules/Ventas';
import PendientesAnulacion from '../views/modules/PendientesAnulacion';

import IngresarReparacion from '../views/modules/IngresarReparacion';
import SeguimientoReparacion from '../views/modules/SeguimientoReparacion';
import Marcas from '../views/modules/Categorias'
import MarcasCatalogo from '../views/modules/MarcasCatalogo';
import ReportePorFecha from '../views/modules/Reportes/Reporteporfecha';
import Abonos from '../views/modules/Abonos'
import Usuarios from '../views/modules/Usuarios';
import Caja from '../views/modules/Caja';
import ServiciosCatalogo from '../views/modules/ServiciosCatalogo';
import ServiciosVentas from '../views/modules/ServiciosVentas';
import ServiciosDigitales from '../views/modules/ServiciosDigitales';
import ChatInbox from '../views/modules/ChatInbox';
import CuentasWebmail from '../views/modules/CuentasWebmail';

import ProtectedRoute from '../components/ProtectedRoute';
import LandingPage from "../views/LandingPage";
import CatalogoPage from "../views/CatalogoPage";
import ServicesPage from "../views/ServicesPage";
import ContactPage from "../views/ContactPage";


const AppRoutes = () => {
  // Definimos las rutas protegidas en un array para evitar repetición
  const protectedRoutes = [
    { path: '/dashboard', component: <Dashboard /> },
    { path: '/configuracion-negocio', component: <ConfiguracionNegocio />, allowedRoles: ['admin'] },
    { path: '/clientes', component: <Clientes /> },
    { path: '/proveedores', component: <Proveedores /> },
    { path: '/productos', component: <Productos /> },
    { path: '/compras', component: <Compras /> },
    { path: '/ventas', component: <Ventas /> },
    { path: '/pendientes-anulacion', component: <PendientesAnulacion />, allowedRoles: ['admin', 'cajero'] },
    { path: '/reparaciones/ingresar', component: <IngresarReparacion /> },
    { path: '/reparaciones/seguimiento', component: <SeguimientoReparacion /> },
    { path: '/marcas', component: <Marcas /> },
    { path: '/categorias-catalogo', component: <MarcasCatalogo />, allowedRoles: ['admin'] },
    { path: '/abonos', component: <Abonos /> },
    { path: '/reporteVentas', component: <ReportePorFecha /> },
    { path: '/caja', component: <Caja />, allowedRoles: ['admin', 'cajero'] },
    { path: '/servicios-ventas', component: <ServiciosVentas />, allowedRoles: ['admin', 'cajero'] },
    { path: '/servicios-catalogo', component: <ServiciosCatalogo />, allowedRoles: ['admin'] },
    { path: '/servicios-digitales', component: <ServiciosDigitales />, allowedRoles: ['admin', 'cajero', 'viewer'] },
    { path: '/usuarios', component: <Usuarios />, allowedRoles: ['admin'] },
    { path: '/inbox', component: <ChatInbox /> },
    { path: '/cuentas-webmail', component: <CuentasWebmail />, allowedRoles: ['admin'] },

  ];

  return (
    <Router>
      <Routes>
        {/* Ruta de Landing Page */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/catalogo" element={<CatalogoPage />} />
        <Route path="/servicios" element={<ServicesPage />} />
        <Route path="/contacto" element={<ContactPage />} />

        {/* Ruta de login */}
        <Route path="/login" element={<Login />} />
        {/* Ruta de Productos */}

        {/* Rutas protegidas */}
        {protectedRoutes.map(({ path, component, allowedRoles }, index) => (
          <Route
            key={index}
            path={path}
            element={
              <ProtectedRoute allowedRoles={allowedRoles}>
                <Layout>{component}</Layout>
              </ProtectedRoute>
            }
          />
        ))}
      </Routes>

    </Router>
  );
};

export default AppRoutes;
